import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'
import commonJs from '@/utils/common'
const BASE_URL = baseUrl +'/system' 

export default {
	/**
	 * 获取公司列表
	**/
	getCompany(params){
		params = commonJs.obj.removeNullKey(params)
		return request({
			url: BASE_URL+'/company',
			method:'get',
			params
		})
	},

	/**
	 * 添加公司
	**/
    companyAdd(data) {
		return request({
		url: BASE_URL+'/company',
	    method: 'POST',
	    data
	  })
	},

	/**
	 * 修改公司
	**/
	companyEdit(id,data){
		return request({
			url: BASE_URL+'/company/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 删除公司
	**/
	companyDel(id){
		return request({
			url: BASE_URL+'/company/'+id,
			method:'DELETE'
		})
	}
}